/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { selectFlags } from '@Quotes/selectors'

import { configurationTabQuery_quote as configurationTabData } from '~/redux-modules/query-refactor/__generated__/configurationTabQuery'
import { coreQuoteDetails_quote as coreQuoteDetailsData } from '~/redux-modules/query-refactor/__generated__/coreQuoteDetails'
import { detailsForIMFeedbackAddReqUnconfiguredConfigModalTabs_quote as detailsForIMFeedbackAddReqUnconfiguredConfigModal } from '~/redux-modules/query-refactor/__generated__/detailsForIMFeedbackAddReqUnconfiguredConfigModalTabs'
import { drawingAnalysisTabQuery_quote as drawingAnalysisTabDataType } from '~/redux-modules/query-refactor/__generated__/drawingAnalysisTabQuery'
import { types as GraphqlTypes } from '~/redux-modules/graphql'
import {
    configurationTabQuery,
    coreQuoteDetailsQuery,
    queryForIMFeedbackAddReqUnconfiguredConfigModalTabs,
    queryForFeedbackThreadsAddReqModalConfigTab,
    drawingAnalysisTabQuery,
} from '~/redux-modules/query-refactor/queries'
import { actions as DFMLayersActions } from '~/redux-modules/dfm-layers'
import { detailsForFeedbackThreadsAddReqModalConfigTab_quote as detailsForFeedbackThreadsAddReqModal } from '~/redux-modules/query-refactor/__generated__/detailsForFeedbackThreadsAddReqModalConfigTab'
import { CORE_QUOTE_DETAILS_QUERY_RESET } from '~/redux-modules/query-refactor/constants'
import { QuoteDetailsDocument } from '~/gql/graphql'

import {
    CONFIGURATION_TAB_QUERY_FAILURE,
    CONFIGURATION_TAB_QUERY_SUCCESS,
    SET_QUOTE_DETAILS_PAGE_LOADING,
    CORE_QUOTE_DETAILS_QUERY_SUCCESS,
    CORE_QUOTE_DETAILS_QUERY_FAILURE,
    LEGACY_QUOTE_DETAILS_QUERY_LOADING,
    LEGACY_QUOTE_DETAILS_QUERY_FAILURE,
    IM_FEEDBACK_ADDREQ_UNCONFIGUREDCONFIGMODAL_TABS_QUERY_SUCCESS,
    IM_FEEDBACK_ADDREQ_UNCONFIGUREDCONFIGMODAL_TABS_QUERY_FAILURE,
    CONFIG_MODAL_THREAD_FEEDBACK_ADD_REQ_QUERY_SUCCESS,
    CONFIG_MODAL_THREAD_FEEDBACK_ADD_REQ_QUERY_FAILURE,
    DRAWING_ANALYSIS_TAB_QUERY_SUCCESS,
    DRAWING_ANALYSIS_TAB_QUERY_FAILURE,
} from './constants'

export const setQuoteDetailsPageLoading = () => ({
    type: SET_QUOTE_DETAILS_PAGE_LOADING,
})

export const configurationTabQuerySuccess = (quote: configurationTabData) => ({
    type: CONFIGURATION_TAB_QUERY_SUCCESS,
    quote,
})

export const configurationTabQueryFailure = (errorMessage: string) => ({
    type: CONFIGURATION_TAB_QUERY_FAILURE,
    errorMessage,
})
export const coreQuoteDetailsQueryReset = () => ({
    type: CORE_QUOTE_DETAILS_QUERY_RESET,
})
export const coreQuoteDetailsQuerySuccess = (quote: coreQuoteDetailsData) => ({
    type: CORE_QUOTE_DETAILS_QUERY_SUCCESS,
    quote,
})

export const coreQuoteDetailsQueryFailure = (errorMessage: string) => ({
    type: CORE_QUOTE_DETAILS_QUERY_FAILURE,
    errorMessage,
})

export const setLegacyQuoteDetailsQueryLoading = (loading = true) => ({
    type: LEGACY_QUOTE_DETAILS_QUERY_LOADING,
    loading,
})

export const legacyQuoteDetailsQueryFailure = (errorMessage: string) => ({
    type: LEGACY_QUOTE_DETAILS_QUERY_FAILURE,
    errorMessage,
})
export const configTabForFeedbackThreadsAddReqModalQuerySuccess = (
    quote: detailsForFeedbackThreadsAddReqModal,
) => ({
    type: CONFIG_MODAL_THREAD_FEEDBACK_ADD_REQ_QUERY_SUCCESS,
    quote,
})

export const configTabForFeedbackThreadsAddReqModalQueryFailure = (
    errorMessage: string,
) => ({
    type: CONFIG_MODAL_THREAD_FEEDBACK_ADD_REQ_QUERY_FAILURE,
    errorMessage,
})

export const imFeedbackAddReqUnconfiguredConfigModalQuerySuccess = (
    quote: detailsForIMFeedbackAddReqUnconfiguredConfigModal,
) => ({
    type: IM_FEEDBACK_ADDREQ_UNCONFIGUREDCONFIGMODAL_TABS_QUERY_SUCCESS,
    quote,
})

export const imFeedbackAddReqUnconfiguredConfigModalQueryFailure = (
    errorMessage: string,
) => ({
    type: IM_FEEDBACK_ADDREQ_UNCONFIGUREDCONFIGMODAL_TABS_QUERY_FAILURE,
    errorMessage,
})

export const drawingAnalysisTabQuerySuccess = (
    quote: drawingAnalysisTabDataType,
) => ({
    type: DRAWING_ANALYSIS_TAB_QUERY_SUCCESS,
    quote,
})

export const drawingAnalysisTabQueryFailure = (errorMessage: string) => ({
    type: DRAWING_ANALYSIS_TAB_QUERY_FAILURE,
    errorMessage,
})
export const getConfigurationTabData = (quoteId: string) => {
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setQuoteDetailsPageLoading())
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient
            const res = await apolloClient.query({
                query: configurationTabQuery,
                variables: { id: quoteId },
                fetchPolicy: 'network-only',
            })

            const {
                data: { quote },
            } = res

            dispatch(configurationTabQuerySuccess(quote))
        } catch (error: any) {
            dispatch(configurationTabQueryFailure(error.message))
        }
    }
}

export const getCoreQuoteDetailsData = (quoteId: string) => {
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            const { isImMaafcoEnabled } = selectFlags(getState())
            const { isCpqFlagV2Enabled } = selectFlags(getState())

            dispatch(setQuoteDetailsPageLoading())
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient
            const res = await apolloClient.query({
                query: coreQuoteDetailsQuery,
                variables: {
                    id: quoteId,
                    isImMaafcoEnabled,
                    isCpqFlagV2Enabled,
                },
                fetchPolicy: 'network-only',
            })

            const {
                data: { quote },
            } = res

            dispatch(coreQuoteDetailsQuerySuccess(quote))
        } catch (error: any) {
            dispatch(coreQuoteDetailsQueryFailure(error.message))
        }
    }
}

export const getLegacyQuoteDetailsData = (quoteId: string) => {
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setLegacyQuoteDetailsQueryLoading(true))
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient
            const res = await apolloClient.query({
                query: QuoteDetailsDocument,
                variables: { id: quoteId },
                fetchPolicy: 'network-only',
            })

            const {
                data: { quote },
            } = res

            dispatch(DFMLayersActions.setQuote(quote))
            dispatch(setLegacyQuoteDetailsQueryLoading(false))
        } catch (error: any) {
            dispatch(legacyQuoteDetailsQueryFailure(error.message))
        }
    }
}

export const getDrawingAnalysisTabData = (quoteId: string) => {
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setQuoteDetailsPageLoading())
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient
            const res = await apolloClient.query({
                query: drawingAnalysisTabQuery,
                variables: { id: quoteId },
                fetchPolicy: 'network-only',
            })

            const {
                data: { quote },
            } = res

            dispatch(drawingAnalysisTabQuerySuccess(quote))
        } catch (error: any) {
            dispatch(drawingAnalysisTabQueryFailure(error.message))
        }
    }
}

export const getConfigModalThreadsFeedbackAddReqTabData = (quoteId: string) => {
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setQuoteDetailsPageLoading())
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient
            const res = await apolloClient.query({
                query: queryForFeedbackThreadsAddReqModalConfigTab,
                variables: { id: quoteId },
                fetchPolicy: 'network-only',
            })

            const {
                data: { quote },
            } = res

            dispatch(configTabForFeedbackThreadsAddReqModalQuerySuccess(quote))
        } catch (error: any) {
            dispatch(
                configTabForFeedbackThreadsAddReqModalQueryFailure(
                    error.message,
                ),
            )
        }
    }
}

export const getIMFeedbackAddReqUnconfiguredConfigModalTabsData = (
    quoteId: string,
) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setQuoteDetailsPageLoading())
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient
            const res = await apolloClient.query({
                query: queryForIMFeedbackAddReqUnconfiguredConfigModalTabs,
                variables: { id: quoteId },
                fetchPolicy: 'network-only',
            })

            const {
                data: { quote },
            } = res

            dispatch(imFeedbackAddReqUnconfiguredConfigModalQuerySuccess(quote))
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            dispatch(
                imFeedbackAddReqUnconfiguredConfigModalQueryFailure(
                    error.message,
                ),
            )
        }
    }
}
